import { COLORS } from '@btime/constants'
import React from 'react'

import { useCanMoveBack, useCanMoveForward, useModalsActions, useModalsState } from './ModalsContext'
import Icon from '../shapes/Icon'
import Link from '../actions/Link'
import Separator from '../helpers/Separator'

const ModalsActions = () => {
  const { history } = useModalsState()
  const { onGoBack, onGoForward } = useModalsActions()
  const canMoveForward = useCanMoveForward()
  const canMoveBack = useCanMoveBack()

  if (history?.length <= 1) return false

  return (
    <>
      <Link block disabled={!canMoveBack} onClick={onGoBack}>
        <Icon name="BsCaretLeftFill" color={COLORS.white} size="1rem" />
      </Link>
      <Link disabled={!canMoveForward} onClick={onGoForward}>
        <Icon name="BsCaretRightFill" color={COLORS.white} size="1rem" />
      </Link>

      <Separator weight={2} vertical />
    </>
  )
}

export default ModalsActions
